export const APP_PROGRESS_ACTIVATE = 'APP_PROGRESS_ACTIVATE'
export const APP_PROGRESS_DEACTIVATE = 'APP_PROGRESS_DEACTIVATE'

export const activateAppProgress = initiator => ({ type: APP_PROGRESS_ACTIVATE, initiator })
export const deactivateAppProgress = initiator => ({ type: APP_PROGRESS_DEACTIVATE, initiator })
